import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, ElementRef, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
// import { ApiService } from '../../shared/services/api.service';

// @Component({
//   selector: 'app-google-analytics-gtag',
//   template: '',
// })
// export class GoogleAnalyticsGTagComponent {
//   trackingCode;

//   constructor(
//     @Inject(PLATFORM_ID) private readonly platformId: Object,
//     private readonly renderer: Renderer2,
//     private readonly el: ElementRef,
//     private apiService: ApiService
//   ) {
//     if (isPlatformBrowser(this.platformId) || isPlatformServer(this.platformId)) {
//         this.apiService.getStoreDetails().subscribe(result => {
//           this.trackingCode  = result['response']['data']['store_json']['settings']['tracking_id'];
//         });
//       const script = this.renderer.createElement('script') as HTMLScriptElement;
//       script.src = `//www.googletagmanager.com/gtag/js?id=${this.trackingCode}`;
//       script.async = true;
//       this.renderer.appendChild(this.el.nativeElement, script);

//       const script2 = this.renderer.createElement('script') as HTMLScriptElement;
//       const scriptBody = this.renderer.createText(`
//         window.dataLayer = window.dataLayer || [];
//         function gtag() {
//           dataLayer.push(arguments);
//         }
//         gtag('js', new Date());

//         gtag('config', '${this.trackingCode}');
//       `);
//       this.renderer.appendChild(script2, scriptBody);
//       this.renderer.appendChild(this.el.nativeElement, script2);
//     }
//   }
// }
import { Injectable } from '@angular/core';
import { Settings } from 'src/app/app.settings';
import { AppSettings } from '../../app.settings';

@Injectable()
export class GoogleAnalyticsService {
  constructor(@Inject(PLATFORM_ID) private readonly platformId: Object,
      private readonly renderer: Renderer2, private appSettings: AppSettings,
      private readonly el: ElementRef) {
       
      }
      
  /**
   * load analytics
   * @param trackingID
   */
  static loadGoogleAnalytics(trackingID: string): void {
    const gaScript1 = document.createElement('script');
    gaScript1.innerText = `window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;ga(\'create\', \'${ trackingID }\', \'auto\');`;

    const gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', 'https://www.google-analytics.com/analytics.js');

    document.documentElement.firstChild.appendChild(gaScript1);
    document.documentElement.firstChild.appendChild(gaScript);

    var head = document.getElementsByTagName("head")[0]

    head.insertBefore(gaScript, head.firstChild);
    head.insertBefore(gaScript1, head.firstChild);
  }

}